.card.form-table-card {
  .card-body {
    padding: 0 1.85rem 1rem;
  }
}

.table.form-table {
  margin-bottom: 0;

  tr:not(:last-child) {
    border-bottom: 1px solid var(--border-secondary);
    td {
      border-bottom: 1px solid var(--border-secondary);
    }
  }

  th,
  td {
    font-size: var(--text-sm);
    vertical-align: middle;
  }

  th {
    color: var(--text-secondary);
    font-weight: var(--font-weight-medium);

    &:first-child {
      padding-left: 0;
    }

    .description {
      color: var(--text-quaternary);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  td {
    color: var(--text-tertiary);

    &:last-child {
      padding-right: 0;
    }
  }

  td,
  th {
    padding-bottom: 16px;
    padding-top: 16px;
  }

  .col-actions {
    text-align: end;
    justify-items: end;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-right: 3px !important;
    white-space: nowrap;
  }

  &.hide-actions {
    .col-actions {
      display: none;
    }
    th,
    td {
      width: auto;
    }
  }

  &.align-top {
    th,
    td {
      vertical-align: top !important;
    }
  }

  &.details-mode {
    .title {
      color: var(--text-secondary);
      font-weight: var(--font-weight-medium);
    }
    .value {
      color: var(--text-quaternary);
      font-weight: var(--font-weight-normal);
    }
  }

  // Label/value rows, not a table: row dividers only, never a box or cell
  // borders, wherever it is placed.
  &,
  thead,
  tbody,
  tfoot,
  tr,
  th,
  td {
    border: 0 !important;
    box-shadow: none !important;
  }
  // A row marked `border-0` belongs with the row below it (a label above its
  // meter, say), so it gets no divider.
  tr:not(:last-child, .border-0) > * {
    border-bottom: 1px solid var(--border-secondary) !important;
  }
}

@media (min-width: 576px) {
  .table.form-table tr th:first-child {
    min-width: 150px;
  }
}

@media (min-width: 768px) {
  .table.form-table tr th:first-child {
    min-width: 200px;
  }
}

// The react-bootstrap `responsive` wrapper would otherwise draw a box around
// it (in dialogs, see `[data-slot='modal-content'] .table-responsive` in
// Metronic's _table.scss).
.table-responsive:has(> .form-table) {
  border: 0 !important;
  box-shadow: none !important;
}
